<script>
    import { onMount } from "svelte";
    import { getLoggedUser } from "./user/service.svelte.js";
    import { token, assetsLimits } from "./user/user.state.svelte.js";
    import Footer from "./_footer/index.svelte";
    import Header from "./_header/index.svelte";
    import Sidebar from "./_sidebar/index.svelte";
    import TermsAndConditions from "../components/terms-and-conditions.svelte";
    import Spinner from "../components/spinner.svelte";
    import LimitsAlert from "../components/limitsAlert.svelte";
    import { searchAssetsCountByKind } from "./asset/assets.state.svelte.js";
    import { locale } from "svelte-i18n";

    let showMobileMessage = $state(false);
    let userPromise;
    let user = $state();

    // if user isn't logged in, redirect to /login?next=CURRENT_ROUTE
    let loginPath = "/login";

    // exclude public routes
    if (!["/"].includes(location.pathname)) {
        loginPath += `?next=${location.pathname}`;
    }

    if (!token.access_token) {
        window.location.href = loginPath;
    } else {
        userPromise = getLoggedUser()
            .then((pUser) => {
                if (!pUser) {
                    window.location.href = loginPath;
                    return;
                }
                if (pUser.language) {
                    locale.set(pUser.language);
                }
                return (user = pUser);
            })
            .catch((e) => {
                window.location.href = loginPath;
                return;
            });
    }

    const closeMsg = () => {
        showMobileMessage = false;
    };

    const shouldShowLimitsWarning = async (limits) => {
        // Return a safe structure if limits aren't loaded yet to prevent undefined errors in template
        if (!limits) return { should_show: false, limits_diff: {} };

        // Svelte 5 Fix: Shallow copy prevents state_unsafe_mutation on reactive objects
        const safeLimits = { ...limits, public_ip_limit: limits.ip_limit };

        let excluded_kinds = ["hostname"];
        let limits_diff = {};

        if (!token.access_token) return { should_show: false, limits_diff: {} };

        let assetCount = await searchAssetsCountByKind({
            filter: { in_scope: true },
        });
        for (const [asset_kind, count] of Object.entries(assetCount)) {
            if (!excluded_kinds.includes(asset_kind)) {
                limits_diff[asset_kind] =
                    safeLimits[`${asset_kind}_limit`] - count;
            }
        }

        for (const diff of Object.values(limits_diff)) {
            if (diff < 1) {
                return {
                    should_show: true,
                    limits_diff: limits_diff,
                };
            }
        }

        return {
            should_show: false,
            limits_diff: limits_diff,
        };
    };

    onMount(async () => {
        // svelte:body doesn't work
        document.documentElement.setAttribute("data-bs-theme", "light");
        document.body.className = "layout-fixed sidebar-expand-lg sidebar-mini bg-body-primary";
        document.documentElement.style.colorScheme = "light";

        // repeat innerWidth because a laptop could have touch feature
        if (
            (feature.touch && window.innerWidth <= 500) ||
            window.innerWidth <= 500
        ) {
            showMobileMessage = true;
        }
    });
</script>

{#await userPromise}
    <div class="mt-5 pt-5">
        <Spinner />
    </div>
{:then loggedUser}
    <div class="app-wrapper">
        <Header />

        {#key $locale}
            <Sidebar />
        {/key}

        <main class="app-main ps-3 pe-3" id="layout-content-wrapper">
            {#await shouldShowLimitsWarning(assetsLimits.data) then data}
                {#if data.should_show}
                    <div class="container-fluid">
                        <LimitsAlert limits_diff={data.limits_diff} />
                    </div>
                {/if}
            {/await}

            {#if showMobileMessage}
                <div class="ms-3 mb-5 mt-3 card vlsk-red">
                    <div class="card-header">
                        <i
                            class="fa fa-times float-end"
                            style="cursor: pointer"
                            title="Cerrar"
                            onclick={closeMsg}
                        ></i>
                    </div>
                    <div class="card-body">
                        <span class="d-block">
                            Para lograr una mejor visualización coloque su
                            dispositivo móvil de forma apaisada.
                        </span>
                    </div>
                </div>
            {/if}

            {#key $locale}
                <slot />
            {/key}
        </main>

        <Footer />
    </div>

    <TermsAndConditions {loggedUser} />
{/await}
